import PropTypes from 'prop-types';
import React from 'react';
import { FlowSteps } from '@piplapps/pipl-ui';
import VettingStep1 from './VettingStep1';
import VettingStep2 from './VettingStep2';
import VettingStep3 from './VettingStep3';
import './LeadVettingStyle.less';

import styles from './LeadVettingFormStyles.module.less';

class VettingFlowSteps extends React.Component {
  state = {
    step: 1,
    completedSteps: [],
  };

  _proceed = () => {
    this.setState((prevState) => {
      return { step: prevState.step + 1 };
    });
  };

  render() {
    const onSubmitStep1 = (values) => {
      this.props.submitVettingStep1(values);
      this._proceed();
    };
    const onSubmitStep2 = (values) => {
      this.props.submitVettingStep2(values);
      this._proceed();
    };
    const onSubmitStep3 = (values) => {
      const allValues = { ...values, product: this.props.product };
      this.props.submitVettingStep3(allValues);
    };

    const goToStep = (step) => {
      this.setState({ step });
    };

    const completeStep = (stepNum) => {
      this.setState((state) => {
        state.completedSteps.push(stepNum);
      });
    };

    const removeCompleted = (stepNum) => {
      this.setState((state) => {
        return { completedSteps: state.completedSteps.filter((step) => step !== stepNum) };
      });
    };

    return (
      <>
        <div className={styles.flowSteps}>
          <FlowSteps
            steps={[
              { name: '', isCompleted: this.state.completedSteps.includes(1) },
              { name: '', isCompleted: this.state.completedSteps.includes(2) },
              { name: '', isCompleted: this.state.completedSteps.includes(3) },
            ]}
            currentStep={this.state.step}
            onStepClick={(step) => goToStep(step)}
          />
        </div>
        <div className={styles.form}>
          {this.state.step === 1 ? (
            <VettingStep1
              isLoading={false}
              onSubmit={(values) => onSubmitStep1(values)}
              fields={this.props.fields}
              completeStep={completeStep}
              removeCompleted={removeCompleted}
              updateFields={this.props.updateFields}
            />
          ) : this.state.step === 2 ? (
            <VettingStep2
              isLoading={false}
              onSubmit={(values) => onSubmitStep2(values)}
              fields={this.props.fields}
              completeStep={completeStep}
              removeCompleted={removeCompleted}
              updateFields={this.props.updateFields}
              product={this.props.product}
            />
          ) : (
            <VettingStep3
              isLoading={this.props.isLoading}
              onSubmit={(values) => onSubmitStep3(values)}
              ref={this._captchaRef}
              completeStep={completeStep}
              removeCompleted={removeCompleted}
              updateFields={this.props.updateFields}
              fields={this.props.fields}
            />
          )}
        </div>
      </>
    );
  }
}

VettingFlowSteps.propTypes = {
  submitVettingStep1: PropTypes.func,
  submitVettingStep2: PropTypes.func,
  submitVettingStep3: PropTypes.func,
  fields: PropTypes.object,
  product: PropTypes.string,
  isLoading: PropTypes.bool,
  updateFields: PropTypes.func,
};

export default VettingFlowSteps;
